import React from 'react';
import { Link } from 'react-router-dom';

function AudiencePaths() {
  return (
    <section className="home-audience app-section">
      <div className="app-container">
        <div className="home-section-intro home-section-intro--compact">
          <span className="app-eyebrow">С чего начать</span>
          <h2>Выберите то, что нужно именно вам</h2>
        </div>

        <div className="home-audience__grid">
          <article className="home-audience__card home-audience__card--client">
   
            <div>
              <span className="home-audience__label">Для клиентов</span>
              <h3>Мне нужна психологическая поддержка</h3>
              <p>
                Найдите специалиста Ассоциации, узнайте о психотерапевтических группах или оставьте заявку на бесплатные консультации.
              </p>
            </div>

            <div className="home-audience__links">
              <Link to="/find-psychologist">Найти психолога <span>→</span></Link>
              <Link to="/benefits/grupp_psy">Психотерапевтические группы <span>→</span></Link>
              <a
                href="https://www.buildin.ai/form/d3348ce1-f52c-4e18-9475-cb1333209568?code=GC2JSA"
                target="_blank"
                rel="noopener noreferrer"
              >
                3 консультации бесплатно <span>↗</span>
              </a>
            </div>
          </article>

          <article className="home-audience__card home-audience__card--professional">

            <div>
              <span className="home-audience__label">Для психологов</span>
              <h3>Я хочу развиваться в профессиональном сообществе</h3>
              <p>
                Интервизии, обучение, открытые семинары и участие в Ассоциации: всё для профессионального роста и обмена опытом.
              </p>
            </div>

            <div className="home-audience__links">
              <Link to="/resources">Возможности для коллег <span>→</span></Link>
              <Link to="/education">Обучение <span>→</span></Link>
              <Link to="/join_association">Вступить в АПП <span>→</span></Link>
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}

export default AudiencePaths;
